import Box from '@components/Box';
import PlacingOrderAddressDropdownItem
  from '../PlacingOrderAddressDropdownItem/PlacingOrderAddressDropdownItem';
import SelectContainer from '@containers/SelectContainer';
import SelectDropdown from '@components/SelectDropdown';
import TextInputContainer from '@containers/TextInputContainer';
import TextInputWithSuggestionsContainer from '@containers/TextInputWithSuggestionsContainer';
import { AddressTemplate, TLabelSelectedItem } from '@api/apiClient';
import { Column, Row } from '@components/Grid';
import {
  countries,
  countryKeyExtractor,
  CountrySelectOption,
  CountrySelectValue,
  CountryType
} from '@components/CountrySelect';
import { IPlacingOrderAddressHKProps } from '../../placing-types';
import { TAddress, TDistrict } from '@api/apiClient/address';
import { useTranslation } from 'react-i18next';

const PlacingOrderAddressFieldsHK: React.FC<IPlacingOrderAddressHKProps> = (props: IPlacingOrderAddressHKProps): React.ReactElement => {
  const {
    control,
    country,
    emptyAddressWithUpdate,
    fullListAddresses,
    handlerGetFullAddress,
    handlerOnClickDeleteAddress,
    handlerSetCurrentAddress,
    handlerSetSelectedSuggestion,
    labelSelectedItem,
    cityDistrict,
    useSuggestions,
    useAddressSuggestionsHKDistrict,
  } = props;

  const { t } = useTranslation();

  const getAddrString = (value: TAddress) => `${value.address} ${value.adcode}`;

  return (
    <>
      <Row>
        <Column phone={12}>
          <Box mb={5}>
            <SelectDropdown<AddressTemplate>
                defaultSelectedItem={emptyAddressWithUpdate}
                items={fullListAddresses}
                keyExtractor={(item: TLabelSelectedItem) => item.id}
                label={t('placingOrderModalWindow.form.address.addressTitleSender')}
                labelSelectedItem={() => handlerGetFullAddress(labelSelectedItem)}
                onItemSelect={(id: string) => handlerSetCurrentAddress(id)}
                renderItem={(props: { item: TLabelSelectedItem }) => (
                    <PlacingOrderAddressDropdownItem
                        handlerGetFullAddress={handlerGetFullAddress}
                        handlerOnClickDeleteAddress={handlerOnClickDeleteAddress}
                        {...props}
                    />
                )}
            />
          </Box>
        </Column>
      </Row>
      <Row>
        <Column phone={5}>
          <Box
              mb={5}
              pr={4}
          >
            <SelectContainer<CountryType, AddressTemplate>
                control={control}
                disabled={country !== 'unknown'}
                items={countries.filter((item: CountryType) => item.id === 'CN' || item.id === 'HK')}
                keyExtractor={countryKeyExtractor}
                name="address.countryCode"
                renderItem={CountrySelectOption}
                renderSelectedItem={CountrySelectValue}
                title={t('placingOrderModalWindow.form.address.country')}
            />
          </Box>
        </Column>
        <Column phone={7}>
          <Box mb={5}>
            <TextInputWithSuggestionsContainer<TDistrict, AddressTemplate>
                control={control}
                name="address.cityDistrict"
                title={t('placingOrderModalWindow.form.address.cityDistrict')}
                useSuggestions={useAddressSuggestionsHKDistrict}
                getName={(value: TDistrict) => value.nameCn}
                getSelectionValue={(value: TDistrict) => value.nameCn}
            />
          </Box>
        </Column>
      </Row>
      <Row>
        <Column phone={12}>
          <Box mb={5}>
            <TextInputWithSuggestionsContainer
                control={control}
                disabled={!cityDistrict}
                name="address.street"
                title={t('placingOrderModalWindow.form.address.street')}
                useSuggestions={useSuggestions}
                onSelect={handlerSetSelectedSuggestion}
                onInput={() => (handlerSetSelectedSuggestion && handlerSetSelectedSuggestion(undefined))}
                getName={getAddrString}
                getSelectionValue={(value: TAddress) => value.address}
            />
          </Box>
        </Column>
      </Row>
      <Row>
        <Column phone={2}>
          <Box
              mb={8}
              pr={4}
          >
            <TextInputContainer
                disabled={!cityDistrict}
                control={control}
                name="address.house"
                title={t('placingOrderModalWindow.form.address.house')}
            />
          </Box>
        </Column>
        <Column phone={3}>
          <Box
              mb={8}
              pr={4}
          >
            <TextInputContainer
                disabled={!cityDistrict}
                control={control}
                name="address.flat"
                title={t('placingOrderModalWindow.form.address.flat')}
            />
          </Box>
        </Column>
        <Column phone={7}>
          <Box mb={8}>
            <TextInputContainer
                disabled={!cityDistrict}
                control={control}
                name="address.zipCode"
                title={t('placingOrderModalWindow.form.address.zipCode')}
            />
          </Box>
        </Column>
      </Row>
    </>
  );
};

export default PlacingOrderAddressFieldsHK;
